import React, { useState } from 'react';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { changeSummaryItemColor } from 'pu-utils/tab_controller';
import AssemblySection from '../../pcb-assembly/components/Assembly';
import PartsSection from '../../pcb-parts/components/Parts';
import FabricationSection from '../../pcb-fabrication/components/Fabrication';

const getItemSection = (item) => {
  switch (item.code) {
    case 'pcbassembly':
      return <AssemblySection itemId={item.id} />;
    case 'pcbparts':
      return <PartsSection itemId={item.id} />;
    case 'pcbfabrication':
      return <FabricationSection itemId={item.id} />;
    default:
      return null;
  }
};

export default () => {
  const defaulActiveKey = bundle_items ? bundle_items[0].code : '';
  const [activeKey, setActiveKey] = useState(defaulActiveKey);

  const onSelect = (key) => {
    if (key !== activeKey) {
      setActiveKey(key);
      changeSummaryItemColor(key);
    }
  }

  return (
    <div className="container" id="project-bundle-tabs">
      <Tabs
        id="project-bundle-tabs"
        activeKey={activeKey}
        onSelect={(k) => onSelect(k)}>
        {bundle_items.map((item) => (
          <Tab
            key={item.code}
            eventKey={item.code}
            code={item.code}
            title={item.name}>
            {getItemSection(item)}
          </Tab>
        ))}
      </Tabs>
    </div>
  )
}
